import * as React from "react"
import { connect } from "react-redux"
import trans from "trans"

import {
    Grid,
    GridCell,
    Select,
    TextInput,
    FieldLabel,
    Icon,
} from "@bdfx/mergado-ui-kit"

import {
    updateInputValue,
} from "app/reducers/form";

import { isMultiSelectCloseOnChange } from "./filters";
import { ReduxList } from "app/types/app-types";
import { AvailableOptionsType } from "../types";
import { FiltersFormType } from "../types/filtertypes";
import { MinMaxType } from "./basic-filters";
import { selectFormValues } from "app/reducers/form";

interface State {
    customSizeRange: boolean
}

interface Props {
    availableOptions: ReduxList<AvailableOptionsType>
    filtersForm: FiltersFormType
    setIsDirty: Function
    updateInputValue: typeof updateInputValue
}

class SizeFilters extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props)

        this.state = {
            customSizeRange: true
        }
    }

    labelWithSwitchCustom = (textToBeTranslated, units) => {
        const label = `${trans(textToBeTranslated)} [${units}]`
        return <FieldLabel>
            <span style={{ paddingRight: '5px' }}>{textToBeTranslated === 'filter_content_length' ? <Icon type="file-o" text={label} /> : label}</span>
            <span style={{ float: 'right', cursor: 'pointer', paddingRight: '10px' }}
                onClick={() => {
                    this.setState({ customSizeRange: !this.state.customSizeRange })
                }}>
                <Icon type={this.state.customSizeRange ? "ellipsis-v" : "edit"} title={this.state.customSizeRange ? trans('custom_filter') : trans('preset_ranges')} color={'#3a3a3a'} />
            </span>
        </FieldLabel>
    }

    render() {
        const { availableOptions, filtersForm } = this.props
        const { customSizeRange } = this.state

        const availableContentLengths = availableOptions.data && availableOptions.data.available_lengths ?
            availableOptions.data.available_lengths.map((o: MinMaxType) => {
                return {
                    label: `${o.label}  [kB]`,
                    value: `${o.value}`
                }
            }) : null

        const availableInputWidths = availableOptions.data && availableOptions.data.available_input_widths ?
            availableOptions.data.available_input_widths.map((o: MinMaxType) => {
                return {
                    label: `${o.label}  [px]`,
                    value: `${o.value}`
                }
            }) : null

        const availableInputHeights = availableOptions.data && availableOptions.data.available_input_heights ?
            availableOptions.data.available_input_heights.map((o: MinMaxType) => {
                return {
                    label: `${o.label}  [px]`,
                    value: `${o.value}`
                }
            }) : null

        //multiselects (arrays not strings):
        let widthFrom = ''
        let widthTo = ''
        let heightFrom = ''
        let heightTo = ''
        let sizeFrom = ''
        let sizeTo = ''

        if (filtersForm && filtersForm.image) {
            if (filtersForm.image.width && typeof filtersForm.image.width[0] != 'undefined') {
                [widthFrom, widthTo] = filtersForm.image.width[0].split('_')
            }
            if (filtersForm.image.height && typeof filtersForm.image.height[0] != 'undefined') {
                [heightFrom, heightTo] = filtersForm.image.height[0].split('_')
            }
            if (filtersForm.image.content_length && Array.isArray(filtersForm.image.content_length) && filtersForm.image.content_length.length > 0) {
                [sizeFrom, sizeTo] = filtersForm.image.content_length[0].split('_')
            }
        }

        return (
            <React.Fragment>
                <GridCell className={(sizeFrom || sizeTo) ? 'active-filter' : ''}>
                    {this.labelWithSwitchCustom('filter_content_length', 'kB')}

                    {customSizeRange || !availableContentLengths ?
                        <Grid className={'two-columns'}>
                            <GridCell>
                                <TextInput
                                    type={'number'}
                                    value={`${sizeFrom ?? ''}`}
                                    step={10}
                                    placeholder={trans('filter_value_from')}
                                    onChange={(val) => {
                                        let newValue = val
                                        if (val < 0) {
                                            newValue = Math.abs(newValue)
                                        }
                                        this.props.updateInputValue('filtersForm', 'image.content_length', [`${newValue ?? ''}_${sizeTo ?? ''}`])
                                        this.props.setIsDirty(true)
                                    }}
                                    onClear={() => {
                                        this.props.updateInputValue('filtersForm', 'image.content_length', [sizeTo ? `_${sizeTo}` : null])
                                        this.props.setIsDirty(true)
                                    }}
                                />
                            </GridCell>

                            <GridCell>
                                <TextInput
                                    type={'number'}
                                    value={`${sizeTo ?? ''}`}
                                    step={10}
                                    placeholder={trans('filter_value_to')}
                                    onChange={(val) => {
                                        let newValue = val
                                        if (val < 0) {
                                            newValue = Math.abs(newValue)
                                        }
                                        this.props.updateInputValue('filtersForm', 'image.content_length', [`${sizeFrom ?? ''}_${newValue ?? ''}`])
                                        this.props.setIsDirty(true)
                                    }}
                                    onClear={() => {
                                        this.props.updateInputValue('filtersForm', 'image.content_length', [sizeFrom ? `${sizeFrom}_` : null])
                                        this.props.setIsDirty(true)
                                    }}
                                />
                            </GridCell>
                        </Grid>
                        :
                        <Select
                            name={`filtersForm.image.content_length`}
                            multiple={true}
                            closeOnChange={isMultiSelectCloseOnChange}
                            options={availableContentLengths}
                            onChange={() => this.props.setIsDirty(true)}
                        />
                    }
                </GridCell>

                <GridCell className={(widthFrom || widthTo) ? 'active-filter' : ''}>
                    {this.labelWithSwitchCustom('input_width', 'px')}

                    {customSizeRange || !availableInputWidths ?
                        <Grid className={'two-columns'}>
                            <GridCell>
                                <TextInput
                                    type={'number'}
                                    value={`${widthFrom ?? ''}`}
                                    step={10}
                                    placeholder={trans('filter_value_from')}
                                    onChange={(val) => {
                                        let newValue = val
                                        if (val < 0) {
                                            newValue = Math.abs(newValue)
                                        }
                                        this.props.updateInputValue('filtersForm', 'image.width', [`${newValue ?? ''}_${widthTo ?? ''}`])
                                        this.props.setIsDirty(true)
                                    }}
                                    onClear={() => {
                                        this.props.updateInputValue('filtersForm', 'image.width', [widthTo ? `_${widthTo}` : null])
                                        this.props.setIsDirty(true)
                                    }}
                                />
                            </GridCell>

                            <GridCell>
                                <TextInput
                                    type={'number'}
                                    value={`${widthTo ?? ''}`}
                                    step={10}
                                    placeholder={trans('filter_value_to')}
                                    onChange={(val) => {
                                        let newValue = val
                                        if (val < 0) {
                                            newValue = Math.abs(newValue)
                                        }
                                        this.props.updateInputValue('filtersForm', 'image.width', [`${widthFrom ?? ''}_${newValue ?? ''}`])
                                        this.props.setIsDirty(true)
                                    }}
                                    onClear={() => {
                                        this.props.updateInputValue('filtersForm', 'image.width', [widthFrom ? `${widthFrom}_` : null])
                                        this.props.setIsDirty(true)
                                    }}
                                />
                            </GridCell>
                        </Grid>
                        :
                        <Select
                            name={`filtersForm.image.width`}
                            multiple={true}
                            closeOnChange={isMultiSelectCloseOnChange}
                            options={availableInputWidths}
                            key={'inputWidth'}
                            onChange={() => this.props.setIsDirty(true)}
                        />
                    }
                </GridCell>

                <GridCell className={(heightFrom || heightTo) ? 'active-filter' : ''}>
                    {this.labelWithSwitchCustom('input_height', 'px')}

                    {customSizeRange || !availableInputHeights ?
                        <Grid className={'two-columns'}>
                            <GridCell>
                                <TextInput
                                    type={'number'}
                                    value={`${heightFrom ?? ''}`}
                                    step={10}
                                    placeholder={trans('filter_value_from')}
                                    onChange={(val) => {
                                        let newValue = val
                                        if (val < 0) {
                                            newValue = Math.abs(newValue)
                                        }
                                        this.props.updateInputValue('filtersForm', 'image.height', [`${newValue ?? ''}_${heightTo ?? ''}`])
                                        this.props.setIsDirty(true)
                                    }}
                                    onClear={() => {
                                        this.props.updateInputValue('filtersForm', 'image.height', [heightTo ? `_${heightTo}` : null])
                                        this.props.setIsDirty(true)
                                    }}
                                />
                            </GridCell>

                            <GridCell>
                                <TextInput
                                    type={'number'}
                                    value={`${heightTo ?? ''}`}
                                    step={10}
                                    placeholder={trans('filter_value_to')}
                                    onChange={(val) => {
                                        let newValue = val
                                        if (val < 0) {
                                            newValue = Math.abs(newValue)
                                        }
                                        this.props.updateInputValue('filtersForm', 'image.height', [`${heightFrom ?? ''}_${newValue ?? ''}`])
                                        this.props.setIsDirty(true)
                                    }}
                                    onClear={() => {
                                        this.props.updateInputValue('filtersForm', 'image.height', [heightFrom ? `${heightFrom}_` : null])
                                        this.props.setIsDirty(true)
                                    }}
                                />
                            </GridCell>
                        </Grid>
                        :
                        <Select
                            name={`filtersForm.image.height`}
                            multiple={true}
                            closeOnChange={isMultiSelectCloseOnChange}
                            options={availableInputHeights}
                            key={'inputHeight'}
                            onChange={() => this.props.setIsDirty(true)}
                        />
                    }
                </GridCell>
            </React.Fragment>
        )
    }
}

function mapStateToProps(state) {
    return {
        availableOptions: state.availableOptions,
        filtersForm: selectFormValues(state, 'filtersForm'),
    }
}

export default connect(mapStateToProps, {
    updateInputValue,
})(SizeFilters)
